@if (loader.getLoading()) {
    <div class="loading-screen" role="status" [attr.aria-label]="'common.loading' | translate">
        <p-progressSpinner styleClass="loading-screen__spinner" strokeWidth="4" />
    </div>
}
